"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseEmittingConversion = void 0;
const get_iterable_from_emitter_1 = require("./get-iterable-from-emitter");
function getBaseEmittingConversion(operation) {
    return function (eventEmitter, options) {
        return operation.call(this, (0, get_iterable_from_emitter_1.getIterableFromEmitter)(eventEmitter, options));
    };
}
exports.getBaseEmittingConversion = getBaseEmittingConversion;
